import { useLocation, Link } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="relative flex flex-col items-center justify-center min-h-[80vh] text-center px-4 bg-background-50">
      <h1 className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-background-200 select-none pointer-events-none z-0">
        404
      </h1>
      <div className="relative z-10">
        <h1 className="text-xl md:text-2xl font-semibold mt-6 text-foreground-950">
          Страница не найдена
        </h1>
        <p className="mt-2 text-base text-foreground-400 font-mono">{location.pathname}</p>
        <p className="mt-4 text-lg md:text-xl text-foreground-500">
          Возможно, страница была удалена или адрес введён неверно.
        </p>
        <Link
          to="/"
          className="mt-8 inline-flex items-center gap-2 h-11 px-6 rounded-full bg-primary-500 text-white text-sm font-medium hover:bg-primary-600 transition-all duration-300 cursor-pointer whitespace-nowrap"
        >
          <i className="ri-home-line"></i>
          Вернуться на главную
        </Link>
      </div>
    </div>
  );
}